module.exports = __webpack_public_path__ + "static/media/Compound_Template_v2.47319e0e.xlsm";